import httpService from "./httpService";

export default {
  findAllByHcCaseMasterId(hcCaseMasterId) {
    let params = {hcCaseMasterId: hcCaseMasterId};
    return httpService.get(`/hcDieuXeSchedule/findAllByHcCaseMasterId`, {params: params});
  },
};



// WEBPACK FOOTER //
// ./src/services/hcDieuXeScheduleService.js